import { agentsHomeEntryPoint } from '@jira/project-settings__agents-home/src/agentsHome.entrypoint.tsx';
import { softwareTeamManagedAgentsRoute } from '@jira/router-routes__project-settings-agents-routes/src/softwareTeamManagedAgentsRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdSpaceAgents } from '@jira/navigation-apps__constants/src/SidebarIdSpaceAgents.tsx';
import { getSettingsNavigationResources } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/product-routes/common/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: agentsHomeEntryPoint,
});

export const softwareTeamManagedAgentsRouteEntry: Route = createEntry(
	softwareTeamManagedAgentsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.agents.jsw-tmp',
		layout: softwareProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdSpaceAgents,
		},
		resources: [...getSettingsNavigationResources()],
		entryPoint: () =>
			expVal('yamato-agents-home-space-settings-beta', 'isEnabled', false)
				? pageEntryPoint
				: notFoundPageEntrypoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
		meta: {
			reporting: {
				packageName: 'jiraProjectSettingsAgentsHome',
				id: 'project-settings.agents.jsw-tmp',
				teamName: 'Yamato',
			},
		},
	}),
);
